"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseWidgetModule = /** @class */ (function () {
    function FuseWidgetModule() {
    }
    return FuseWidgetModule;
}());
exports.FuseWidgetModule = FuseWidgetModule;
